<template>
    <div class="container">
        <div class="page-title pull-left">
            <h2 class="entry-title">
                <span v-if="getPathName('booking')">{{ booking[getCurrentLocale] }}</span>
                <span v-if="getPathName('services')">{{ services[getCurrentLocale] }}</span>
                <span v-if="getPathName('rebooking')">{{ rebooking[getCurrentLocale] }}</span>
                <span v-if="getPathName('mybookings')">{{ mybookings[getCurrentLocale] }}</span>
                <span v-if="getPathName('flightplan')">{{ flightplan[getCurrentLocale] }}</span>

                <span v-if="getPathName('pressreleases')">{{ pressreleases[getCurrentLocale] }}</span>
                <span v-if="getPathName('career')">{{ career[getCurrentLocale] }}</span>

                <span v-if="getPathName('infos-luggage')">{{ infos_luggage[getCurrentLocale] }}</span>
                <span v-if="getPathName('infos-dangerous-goods')">{{ infos_dangerous_goods[getCurrentLocale] }}</span>
                <span v-if="getPathName('infos-prohibited-items')">{{ infos_prohibited_items[getCurrentLocale] }}</span>
                <span v-if="getPathName('infos-additional-services')">{{ infos_additional_services[getCurrentLocale] }}</span>
                <span v-if="getPathName('infos-serviceonboard')">{{ infos_serviceonboard[getCurrentLocale] }}</span>
                <span v-if="getPathName('infos-seat-reservation')">{{ infos_seat_reservation[getCurrentLocale] }}</span>
                <span v-if="getPathName('infos-fare-conditions')">{{ infos_fare_conditions[getCurrentLocale] }}</span>
                <span v-if="getPathName('infos-complaints')">{{ infos_complaints[getCurrentLocale] }}</span>
                <span v-if="getPathName('infos-group-booking')">{{ infos_group_booking[getCurrentLocale] }}</span>
            </h2>
        </div>
        <ul class="breadcrumbs pull-right">
            <li><a href="#">HOME</a></li>
            <li class="active">
                <!-- <span v-if="getPathName('booking')">{{ booking[getCurrentLocale] }}</span>
                <span v-if="getPathName('services')">{{ services[getCurrentLocale] }}</span>
                <span v-if="getPathName('rebooking')">{{ rebooking[getCurrentLocale] }}</span>

                <span v-if="getPathName('mybookings')">{{ mybookings[getCurrentLocale] }}</span>
                <span v-if="getPathName('flightplan')">{{ flightplan[getCurrentLocale] }}</span>

                <span v-if="getPathName('pressreleases')">{{ pressreleases[getCurrentLocale] }}</span>
                <span v-if="getPathName('career')">{{ career[getCurrentLocale] }}</span>

                <span v-if="getPathName('infos-luggage')">{{ infos_luggage[getCurrentLocale] }}</span>
                <span v-if="getPathName('infos-dangerous-goods')">{{ infos_dangerous_goods[getCurrentLocale] }}</span>
                <span v-if="getPathName('infos-prohibited-items')">{{ infos_prohibited_items[getCurrentLocale] }}</span>
                <span v-if="getPathName('infos-additional-services')">{{ infos_additional_services[getCurrentLocale] }}</span>
                <span v-if="getPathName('infos-serviceonboard')">{{ infos_serviceonboard[getCurrentLocale] }}</span>
                <span v-if="getPathName('infos-seat-reservation')">{{ infos_seat_reservation[getCurrentLocale] }}</span>
                <span v-if="getPathName('infos-fare-conditions')">{{ infos_fare_conditions[getCurrentLocale] }}</span>
                <span v-if="getPathName('infos-complaints')">{{ infos_complaints[getCurrentLocale] }}</span>
                <span v-if="getPathName('infos-group-booking')">{{ infos_group_booking[getCurrentLocale] }}</span> -->
            </li>
        </ul>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {

        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                booking: {
                    en: 'Flight Booking',
                    de: 'Flugbuchung',
                },
                services: {
                    en: 'mein-wunschplatz',
                    de: 'mein-wunschplatz',
                },
                rebooking: {
                    en: 'Rebooking',
                    de: 'Umbuchung',
                },
                mybookings: {
                    en: 'My Bookings',
                    de: 'Meine Buchungen',
                },
                flightplan: {
                    en: 'Flight plan',
                    de: 'Flugplan',
                },
                pressreleases: {
                    en: 'Press releases',
                    de: 'Pressemitteilungen',
                },
                career: {
                    en: 'Career',
                    de: 'Karriere',
                },
                infos_luggage: {
                    en: 'Lugagge',
                    de: 'Gepäck',
                },
                infos_dangerous_goods: {
                    en: 'Dangerous Goods',
                    de: 'Gefährliche Güter',
                },
                infos_prohibited_items: {
                    en: 'Prohibited Items',
                    de: 'Verbotene Gegenstände',
                },
                infos_additional_services: {
                    en: 'Additional Services',
                    de: 'Zusatzleistungen',
                },
                infos_serviceonboard: {
                    en: 'Service on board',
                    de: 'Service an Board',
                },
                infos_seat_reservation: {
                    en: 'Seat Reservation',
                    de: 'Sitzplatzreservierung',
                },
                infos_fare_conditions: {
                    en: 'Fare Conditions',
                    de: 'Tarifbestimmungen',
                },
                infos_complaints: {
                    en: 'Complaints',
                    de: 'Reklamationen',
                },
                infos_group_booking: {
                    en: 'Group Booking',
                    de: 'Gruppenbuchung',
                },
                // >>> ------------------------------------
                currentUrl: ''
            };

        }, // eof data()
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'getCurrentLocale',
            ]),

        }, // eof computed{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Methods */
        methods: {

            /******************************************************************* 'Utilities - Common'
            * Utilities:
            *******************************************************************/
            /*******************************************************************
            * getPathName()
            *
            * Desc:
            * Note:
            *
            * @param {string} pathname ()
            * @param
            * @return
            */
            getPathName: function (pathname) {

                var me = this,
                    currentUrl = window.location.pathname,
                    currentUrl = currentUrl.slice(1,-1);


                // me.$toc('>>> shared/header/LanguageList.vue >>> getPathName');
                if (pathname === currentUrl) {
                    return true;
                } else {
                    return false;
                }

            }, // eof getPathName()

        }, // eof methods()
        /* <<< ****************************************************************/

    };
</script>
